import React from 'react';
import { useCountUp } from '../../hooks/useCountUp';

interface AnimatedAmountProps {
  /** Final numeric value to count up to. */
  value: number;
  /** Formatter that turns a number into its display string. */
  format: (n: number) => string | number;
  /** Animation duration in ms. */
  duration?: number;
  className?: string;
}

/**
 * Renders a financial figure that counts up from 0 to `value` on mount.
 * Keeps the exact final value (the animation ends precisely on target) and
 * runs the provided `format` each frame so currency formatting is preserved.
 */
export const AnimatedAmount: React.FC<AnimatedAmountProps> = ({
  value,
  format,
  duration = 1200,
  className = '',
}) => {
  const animated = useCountUp(value, duration);
  return <span className={className}>{format(animated)}</span>;
};

export default AnimatedAmount;
